<template>
  <div>
    <!-- Tab -->
    <tabs-menu
      class="product-tab-menu"
      :menu="menuTabs"
      :active="activeTabs"
    />

    <b-card
      class="overflow-hidden"
      no-body
    >
      <!-- Tabel -->
      <GiftProducts v-if="canAccess('manage', 'Product') && canRoles('admin') && activeTabs === 4" />

      <CartProducts v-else-if="canAccess('manage', 'Product') && canRoles('admin') && activeTabs === 5" />

      <ExternalProductNew v-else-if="useNewExternalProduct && canAccess('manage', 'Product') && canRoles('admin') && activeTabs === 3" />

      <ExternalProduct v-else-if="!useNewExternalProduct && canAccess('manage', 'Product') && canRoles('admin') && activeTabs === 3" />

      <AllProducts v-else-if="canAccess('read', 'Product') && activeTabs === 1" />

      <StockProduct v-else-if="canAccess('read', 'Product') && activeTabs === 2" />

    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import {
  BCard,
} from 'bootstrap-vue'
import TabsMenu from '@/layouts/components/custom/TabsMenu.vue'
import GiftProducts from '../../layouts/components/table/GiftProducts.vue'
import CartProducts from '../../layouts/components/table/CartProducts.vue'
import ExternalProduct from '../../layouts/components/table/ExternalProduct.vue'
import ExternalProductNew from '../../layouts/components/table/ExternalProductNew.vue'
import AllProducts from '../../layouts/components/table/AllProducts.vue'
import StockProduct from '../../layouts/components/table/StockProduct.vue'

export default {
  components: {
    BCard,

    GiftProducts,
    CartProducts,
    ExternalProduct,
    ExternalProductNew,
    AllProducts,
    StockProduct,
    TabsMenu,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      searchKeyword: '',
      isPending: false,
      detailProductExternal: '',
      useNewExternalProduct: true,

      statusFilter: null,
      statusOptions: [
        { label: 'Semua', key: null, value: null },
        { label: 'Non URL Afiliasi', key: 'has_unchanged_url', value: true },
        { label: 'Sudah terbeli', key: 'is_purchase_true', value: true },
        { label: 'Belum dibeli', key: 'is_purchase', value: false },
      ],
    }
  },
  mounted() {
    const externalProductPageVersion = localStorage.getItem('externalProductPageVersion')

    if (!externalProductPageVersion || externalProductPageVersion === 'new') {
      this.useNewExternalProduct = true
    } else {
      this.useNewExternalProduct = false
    }
  },
  computed: {
    ...mapState('products', ['products', 'emptyProducts', 'externalProducts']),
    activeTabs() {
      return !this.$route.query.tab ? 1 : parseInt(this.$route.query.tab, 0)
    },
    menuTabs() {
      return [
        {
          access: this.canAccess('read', 'Product'),
          title: 'Semua Produk',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: { status: undefined },
        },
        {
          access: this.canAccess('manage', 'Product') && this.canRoles('admin'),
          title: 'Stok Produk',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: { status: undefined },
        },
        // {
        //   access: this.canAccess('read', 'Product'),
        //   title: 'Produk Kosong',
        //   action: null,
        //   payload: null,
        //   otherAction: null,
        //   otherQuery: { status: undefined },
        // },
        {
          access: this.canAccess('manage', 'Product') && this.canRoles('admin'),
          title: 'Produk Eksternal',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: { status: undefined },
        },
        {
          access: this.canAccess('manage', 'Product') && this.canRoles('admin'),
          title: 'Produk Registry (Variant Dihapus)',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: { status: undefined },
        },
        {
          access: this.canAccess('manage', 'Product') && this.canRoles('admin'),
          title: 'Produk Keranjang (Variant Dihapus)',
          action: null,
          payload: null,
          otherAction: null,
          otherQuery: { status: undefined },
        },
      ]
    },
  },
  methods: {
    ...mapActions('products', ['getProducts', 'getEmptyProducts', 'getProductExternal']),
  },
}
</script>

<style lang="scss" scoped>
$primary: #7367f0;

.product-info {
  display: flex;
  &__image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 8px;
  }
}

.product-list {
  &__tabs {
    display: flex;
  }
  &__filters {
    padding: 16px 20px;
    font-size: 14px !important;
  }
  &__footer {
    padding: 16px 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.tab-item {
  padding: 12px 28px;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #bdbdbd;
  &:hover {
    cursor: pointer;
    color: $primary;
  }
  &.active {
    color: $primary;
    border-color: $primary;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
